import axios from "axios";

function getApiBaseUrl() {
  return process.env.REACT_APP_API_URL || "";
}

function getAuthHeaders() {
  const token =
    localStorage.getItem("sundorbonToken") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("sundorbonToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * GET ParcelBookingInformation/GetParcelBookingHistoryByUserId/{userId}
 */
export async function fetchParcelBookingHistoryByUserId(userId) {
  const { data } = await axios.get(
    `${getApiBaseUrl()}ParcelBookingInformation/GetParcelBookingHistoryByUserId/${userId}`,
    { headers: getAuthHeaders() },
  );
  return data;
}

/**
 * GET ParcelBookingInformation/GetUserBookingSummerybyUserId/{userId}
 */
export async function fetchUserBookingSummaryByUserId(userId) {
  const { data } = await axios.get(
    `${getApiBaseUrl()}ParcelBookingInformation/GetUserBookingSummerybyUserId/${userId}`,
    { headers: getAuthHeaders() },
  );
  return data;
}

/**
 * GET ParcelBookingInformation/GetParcelHistory — same as admin Bookings page.
 */
export async function fetchAdminParcelHistory() {
  const token = localStorage.getItem("token");
  const headers = token
    ? { accept: "*/*", Authorization: `Bearer ${token}` }
    : { accept: "*/*" };

  const { data } = await axios.get(
    `${getApiBaseUrl()}ParcelBookingInformation/GetParcelHistory`,
    { headers },
  );
  return Array.isArray(data) ? data : [];
}

/**
 * GET ParcelBookingInformation/GetAnalyticsData
 * @returns {Promise<import('../types/adminBookingAnalytics.types').AdminBookingAnalyticsResponse>}
 */
export async function fetchAdminBookingAnalytics() {
  const token = localStorage.getItem("token");
  const headers = token
    ? { accept: "*/*", Authorization: `Bearer ${token}` }
    : { accept: "*/*" };

  const { data } = await axios.get(
    `${getApiBaseUrl()}ParcelBookingInformation/GetAnalyticsData`,
    { headers },
  );
  return data;
}
